import { useEffect, useState } from "react";
import * as CPL from "@teamsparta/cross-platform-logger";

import { useWindowScrollY } from "@/businessLogics/_common/util-browser";
import { marketingGA4 } from "../../../../lib/gtag";

CPL.initCPLog(
  process.env.FLOUNDER_KEY,
  process.env.AMPLITUDE_KEY,
  process.env.HACKLE_SDK_KEY,
  !JSON.parse(process.env.IS_PROD)
);

export const sendLog = async (action, data = {}) => {
  CPL.sendCPLog(action, data);
  marketingGA4(action, data);
};

export const logClickLoginButton = () => {
  sendLog("swc_loginPage_click_button", {
    button_text: "다음",
    button_name: "로그인하기",
    button_href: `${process.env.BASE_NEXT_URL}`,
  });
};

export const logNotificationCompleted = (courseName?: string) => {
  sendLog("swc_notification_completed", { course_name: courseName });
};

export const logClickPMLandingButton = () => {
  sendLog("swc_mainPage_click_button", {
    button_text: "PM 코스 지원하기",
    button_href: `${process.env.BASE_NEXT_URL}/apply`,
    page_name: "PM코스",
  });
};

export const logPMLandingApplyClick = ({ button_text, location }) => {
  sendLog("sw_PM_apply_click", {
    button_text,
    location,
  });
};

export const logClickMktLandingButton = () => {
  sendLog("swc_mainPage_click_button", {
    button_text: "마케터 코스 지원하기",
    button_href: `${process.env.BASE_NEXT_URL}/apply`,
    page_name: "마케터코스",
  });
};

export const logCourseTitle = {
  PM: "PM",
  pm: "PM",
  마케터: "marketer",
  mkt: "marketer",
  UIUX: "UIUX",
};

export const logClickHubLandingButton = (
  course_title: string,
  round: string
) => {
  sendLog("sw_mainPage_courseDetail_click", {
    course_title: logCourseTitle[course_title],
    round,
  });
};

export const logClickCta = (pageName?: string) => {
  let page_name = "메인";

  if (pageName.includes("pm")) {
    page_name = "PM코스";
  }

  sendLog("swc_mainPage_click_floating", {
    floating_text: "PM 코스 지원하기",
    next_href: `${process.env.BASE_NEXT_URL}/apply`,
    next_page: "지원서 작성",
    page_name,
  });
};

export const logClickApplication1Button = () => {
  sendLog("swc_application1Page_click_button", {
    button_text: "다음",
    button_name: "1차 지원서 제출하기",
    button_href: `${process.env.BASE_NEXT_URL}/apply`,
  });
};

export const logCompleteApplication1 = (data) => {
  const {
    course,
    onlineUserId,
    age,
    degree,
    career,
    reference,
    referenceDetail,
    round,
    roundId,
    applicantId,
    experience,
    careerChangePeriod,
    careerYear,
    itExperience,
  } = data;
  sendLog("sw_application1_completed", {
    course: logCourseTitle[course],
    online_user_id: onlineUserId,
    age,
    degree,
    career,
    reference,
    reference_detail: referenceDetail,
    round,
    round_id: roundId,
    applicant_id: applicantId,
    experience,
    careerChangePeriod,
    careerYear,
    itExperience,
  });
};

export const logClickApplication2Button = () => {
  sendLog("swc_application2Page_click_button", {
    button_text: "제출하기",
    button_name: "2차 지원서 제출하기",
    button_href: `${process.env.BASE_NEXT_URL}/applied`,
  });
};

export const logCompleteApplication2 = (data) => {
  const {
    course,
    onlineUserId,
    degree,
    career,
    reference,
    referenceDetail,
    round,
    roundId,
    applicantId,
    experience,
    motivation,
    motivationLength,
  } = data;
  sendLog("sw_application2_completed", {
    course: logCourseTitle[course],
    online_user_id: onlineUserId,
    degree,
    career,
    reference,
    reference_detail: referenceDetail,
    round,
    round_id: roundId,
    applicant_id: applicantId,
    experience,
    motivation,
    motivation_length: motivationLength,
  });
};

export const logClickAppliedPageButton = () => {
  sendLog("swc_applicationCompletedPage_click_button", {
    button_text: "자주하는 질문 더보기",
    button_href:
      "https://teamsparta.notion.site/9b824818ac8e466a8b9cbf7281f0fef1",
  });
};

export const logClickReservePageButton = (nextHref: string) => {
  sendLog("swc_applicationAcceptedPage_click_button", {
    button_text: "화상 인터뷰 예약하기",
    button_name: "interview_booking",
    button_href: nextHref,
  });
};

export const logClickPaymentPageButton = () => {
  sendLog("swc_checkoutPage_click_button", {
    button_text: "결제하기",
    button_href: "아임포트 결제 창",
  });
};

export const logPurchaseComplete = (data) => {
  const {
    course,
    onlineUserId,
    degree,
    career,
    reference,
    referenceDetail,
    roundId,
    round,
    applicantId,
    experience,
    motivation,
    motivationLength,
    interviewer,
    interviewScore,
    interviewDate,
    beginTime,
    endTime,
    paymentWay,
  } = data;
  sendLog("sw_purchase_completed", {
    course: logCourseTitle[course],
    online_user_id: onlineUserId,
    round_id: roundId,
    round,
    applicant_id: applicantId,
    begin_time: new Date(beginTime),
    end_time: new Date(endTime),
    payment_way: paymentWay,
  });
};

export const logClickReceiptPageButton = (type: string) => {
  sendLog("swc_paymentDonePage_click_button", {
    button_text: type === "ot" ? "사전 준비 과정 시작하기" : "1:1 문의하기",
    button_href:
      type === "ot"
        ? `${process.env.ONLINE_BASE_URL}/classroom`
        : "https://spartacodingclub.channel.io/user-chats/6370c93beec96b11941d?mode=direct&page=aHR0cHMlM0ElMkYlMkZzcGFydGFjb2RpbmdjbHViLmNoYW5uZWwuaW8lMkZzdXBwb3J0LWJvdHMlMkY1MTQ1Ng%3D%3D",
  });
};

export const logLandingScroll = (div_depth: number, div_name: string) => {
  sendLog("swc_mainPage_scroll", {
    div_depth: div_depth,
    div_name: div_name,
  });
};

export const logClickLnbItem = (
  text: string,
  href: string,
  isOutsideLink?: boolean
) => {
  let button_href = `${process.env.BASE_NEXT_URL}${href}`;
  // 외부 링크일 경우
  if (isOutsideLink) {
    button_href = href;
  }

  // 알림신청 버튼은 링크가 없음
  if (href === "alim" || href === "alert") {
    button_href = "";
  }

  sendLog("sw_gnb_click", {
    button_text: text,
    button_href,
  });
};

export const divName = [
  "hero",
  "망설임",
  "돌파구",
  "sellingPoint",
  "seniors",
  "solution",
  "knowhow",
  "코칭",
  "취업지원시스템",
  "협력사",
  "교육기간방법",
  "커리큘럼",
  "모집개요",
  "수강료",
  "마지막 CTA",
];

export const useScrollLog = (refList, logFunction) => {
  const divFlags = Array(refList.length).fill(0);
  const scrollY = useWindowScrollY();
  const [flags, setFlags] = useState(divFlags);

  useEffect(() => {
    // 이미 로그를 다 찍었다면 실행하지 않음
    if (flags.reduce((prev, curr) => prev + curr, 0) === flags.length) {
      return;
    }
    if (typeof window !== "undefined") {
      const innerHeight = window.innerHeight;
      refList.map((ref, index) => {
        if (scrollY + innerHeight >= ref?.current?.offsetTop && !flags[index]) {
          logFunction(index + 1, divName[index]);
          let tempState = flags;
          tempState[index] = 1;
          setFlags(tempState);
        }
      });
    }
  }, [scrollY]);
};

export const logClickReservedPageCta = (
  button_text: string,
  button_href: string
) => {
  sendLog("sw_itreservedPage_enter_click", {
    button_text,
    button_href,
  });
};

export const logClickHerbEventDiv = (
  button_text: string,
  button_href: string
) => {
  sendLog("sw_mainPage_eventdiv_click", {
    button_text,
    button_href,
  });
};
